module.exports = __webpack_public_path__ + "static/media/PHOTO-BANGKOK.049d6666.jpg";